function generateRandomTime(baseTime, minOffset, maxOffset) {
  const baseDate = new Date(baseTime);
  const randomOffset =
    Math.floor(Math.random() * (maxOffset - minOffset + 1)) + minOffset;
  baseDate.setMinutes(baseDate.getMinutes() + randomOffset);
  return baseDate.toLocaleString("en-US", { hour12: true });
}

function generateDemoRows(count) {
  const pickers = [
    "Zayden Cole",
    "Olivia Hayes",
    "Mason Clarke",
    "Emma Johnson",
    "Liam Smith",
  ];
  const jobPrefix = "V27639";
  const orderPrefix = ["TOY", "BYD", "CAPS", "FORD", "BMW"];
  const baseTime = new Date("2025-10-02T09:00:00");

  const rows = [];

  for (let i = 0; i < count; i++) {
    const id = i + 1;
    const jobNo = jobPrefix + (56 + i);
    const custOrder = orderPrefix[i % orderPrefix.length] + (100 + i);
    const orderLine = Math.floor(Math.random() * 10) + 1;
    const orderedDate = generateRandomTime(baseTime, 0, 60);
    const picker = pickers[i % pickers.length];
    const orderLoaded = generateRandomTime(new Date(orderedDate), 30, 90);
    const orderReachedBay = generateRandomTime(new Date(orderLoaded), 30, 90);
    const orderMarkedCompleted = generateRandomTime(
      new Date(orderReachedBay),
      5,
      60
    );

    // Calculate total duration
    const durationMs = new Date(orderMarkedCompleted) - new Date(orderedDate);
    const durationMins = Math.floor(durationMs / 60000);
    const totalDuration =
      durationMins >= 60
        ? `${Math.floor(durationMins / 60)} hr ${durationMins % 60} mins`
        : `${durationMins} mins`;

    rows.push({
      id,
      jobNo,
      custOrder,
      orderLine,
      orderedDate,
      picker,
      orderLoaded,
      orderReachedBay,
      orderMarkedCompleted,
      totalDuration,
    });
  }

  return rows;
}

export const rows = generateDemoRows(35);
